import { SVGRenderer } from '../core/SVGRenderer';

export abstract class BaseObject {
  public id: string;
  public visible: boolean = true;
  public opacity: number = 1.0;
  public color: string;
  public strokeWidth: number;
  public element: SVGElement | null = null;
  protected renderer: SVGRenderer;

  constructor(renderer: SVGRenderer, id?: string) {
    this.renderer = renderer;
    this.id = id || `obj_${Math.random().toString(36).substr(2, 9)}`;
    this.color = renderer.config.lineColor;
    this.strokeWidth = 2;
  }

  public abstract render(): SVGElement;
  public abstract update(): void;

  public setOpacity(opacity: number): void {
    this.opacity = Math.max(0, Math.min(1, opacity));
    if (this.element) {
      this.element.setAttribute('opacity', String(this.opacity));
    }
  }

  public setVisible(visible: boolean): void {
    this.visible = visible;
    if (this.element) {
      this.element.style.display = visible ? 'block' : 'none';
    }
  }

  public setColor(color: string): void {
    this.color = color;
    this.update();
  }

  public remove(): void {
    if (this.element && this.element.parentElement) {
      this.element.parentElement.removeChild(this.element);
    }
  }
}
